import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import ImpersonationIndicator from './ImpersonationIndicator';
import useLanguageSwitcher from '../../hooks/useLanguageSwitcher';

const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Initialize language switcher
  useLanguageSwitcher();

  return (
    <div className="flex h-screen bg-white">
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <ImpersonationIndicator />
        <Header onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)} />
        <main className="flex-1 overflow-auto bg-white px-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout; 